export class RelationType {
  id: number;
  code: string;
  name: string;
}
